import React, { Component } from 'react';
import styles from '../style.less';

export default class Empty extends Component {
  render() {
    const { tip } = this.props;
    return (
      <div className={styles.emptyWrap}>
        <div className={styles.emptyImg}>
          <img style={{margin: 'auto'}} src={require('@/assets/images/no-record.png')} alt=""/>
        </div>
        <div className={styles.emptyText}>{tip ? tip : '暂无记录'}</div>
      </div>
    );
  }
}